import { EMR_APIS } from "@/api_framework/api_config";

import { IEMRListForUserAndPetResponse, IEMRListForUserAndPetResponseData } from "@/api_framework/api_modals/EMRs";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useListEMRUserAndPetAPI = () => {
  const [vmsEMRs, setVMSEMRs] = useState<IEMRListForUserAndPetResponseData[]>([]);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (userId: string, petId: string) => {
      dispatch(
        setLoading({
          key: "isEMRFetchInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response: IEMRListForUserAndPetResponseData[] = await axios
          .get(EMR_APIS?.GET_EMR_USER_AND_PET?.baseURL ?? "", {
            params: {
              customer_id: userId,
              pet_id: petId,
            },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IEMRListForUserAndPetResponse>) => {
            dispatch(
              setLoading({
                key: "isEMRFetchInProgress",
                status: false,
              }),
            );
            if (res.data.status === true && res.data) {
              setVMSEMRs(res.data.data);
              return res.data.data;
            } else {
              setVMSEMRs([]);
              return null;
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            setVMSEMRs([]);
            dispatch(
              setLoading({
                key: "isEMRFetchInProgress",
                status: false,
              }),
            );
            captureError(e);
            return null;
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { vmsEMRs, execute };
};
